import { call, put, takeLatest } from 'redux-saga/effects'
import {
  generatePndsScoreRequest,
  generatePndsScoreSuccess,
  generatePndsScoreError,
  pushMssageToSnackbar,
} from '../slices'
import { generatePndsScore } from '../../api'

// Worker Saga: Generate PNDS Score from image & data
function* handlePNDSScoreGeneration(action) {
  try {
    const response = yield call(generatePndsScore, action.payload)
    yield put(generatePndsScoreSuccess(response))
  } catch (error) {
    const errMsg = error.message || 'Unknown Error Occurred'
    yield put(
      pushMssageToSnackbar({
        message: errMsg,
        type: 'error',
      }),
    )
    yield put(generatePndsScoreError(errMsg))
  }
}

// Watcher Saga
function* foodscanSaga() {
  yield takeLatest(generatePndsScoreRequest.type, handlePNDSScoreGeneration)
}

export default foodscanSaga
